import React from 'react';

interface SpaceXProps {
  width: string | number;
  mdWidth?: string | number;
  shrink?: boolean;
}

function SpaceX({ width, mdWidth, shrink = false }: SpaceXProps) {
  if (mdWidth) {
    return (
      <>
        <div
          className="hidden h-full md:block"
          style={{ width: mdWidth }}
        ></div>
        <div className="h-full md:hidden" style={{ width }}></div>
      </>
    );
  }
  return (
    <div
      className={`h-full ${shrink ? 'shrink-0' : ''}`}
      style={{ width }}
    ></div>
  );
}

export default SpaceX;
